import {Description} from './Description';
import {TypeRensA} from './TypeRensA';
import {TypeCaracteristiquesMAPA} from './TypeCaracteristiquesMAPA';
import {InfosSup} from './InfosSup';
import {TypeDureeMarche} from './TypeDureeMarche';
import {TypeNatureMarcheLot} from './TypeNatureMarcheLot';
import {Conditions} from './Conditions';
import {TypeJustif} from './TypeJustif';
import {Procedure} from './Procedure';
import {TypeLotsMAPA} from './TypeLotsMAPA';
import {Renseignements} from './Renseignements';
import {TypeCrJugement} from './TypeCrJugement';
import {TypeOuiNon} from './TypeOuiNon';
import { TypeDelais } from './TypeDelais';
export class Initial {

	public infosSup: InfosSup;

	public marcheUnique: string;

	public justifications: TypeJustif;

	public description: Description;

	public adressesComplt: TypeRensA;

	public procedure: Procedure;

	public criteres: TypeCrJugement;

	public caracteristiques: TypeCaracteristiquesMAPA;

	public lots: TypeLotsMAPA;

  public isAlloti: string;

	public delais: TypeDelais;

	public renseignements: Renseignements;

	public duree: TypeDureeMarche;

	public delaiUrgence: string;

	public conditions: Conditions;

	public natureMarche: TypeNatureMarcheLot;

	constructor() {
		 		this.infosSup = new InfosSup();
		   this.marcheUnique = '';
		   this.justifications = new TypeJustif();
		   this.description = new Description();
		   this.adressesComplt = new TypeRensA();
		   this.procedure = new Procedure();
		   this.criteres = new TypeCrJugement();
		   this.caracteristiques = new TypeCaracteristiquesMAPA();
		   this.lots = new TypeLotsMAPA();
		   this.renseignements = new Renseignements();
		   this.duree = new TypeDureeMarche();
		   this.delaiUrgence = '';
		   this.conditions = new Conditions();
		   this.natureMarche = new TypeNatureMarcheLot();
		   this.delais = new TypeDelais();
       this.isAlloti = null;
	}
}
